import restaurantInstance from '../../instance'

const fetchTableSplits = (tableId) => {
  return restaurantInstance.get(`/tables/${tableId}/splits`)
}

export default fetchTableSplits
